import api from './api';

export async function fetchPromotores() {
  const resp = await api.get('/promotores', {
    params: {
      per_page: 10000,
      status: 'active',
    },
  });
  return resp.data?.data || [];
}
